import { productAPI } from '../services/api';

/** Canonical combo definitions — resolved against live product data */
export const COMBO_CATALOG = [
  {
    slug: 'spiderman-combo',
    name: 'Spider-Man Bundle',
    description: 'Spiderman Web Keychain + Spiderman ID Card Holder + Spider Man keychain',
    combo_price: '399',
    combo_price_themed: '499',
    items: [
      { slug: 'spiderman-web-keychain', quantity: 1 },
      { slug: 'spiderman-id-card-holder', quantity: 1 },
      { slug: 'spider-man', quantity: 1 },
    ],
  },
  {
    slug: 'batman-combo',
    name: 'Batman Bundle',
    description: 'Batman Fidget Keychain + Batman ID Card Holder',
    combo_price: '399',
    combo_price_themed: '499',
    items: [
      { slug: 'batman-fidget-keychain', quantity: 1 },
      { slug: 'batman-id-card-holder', quantity: 1 },
    ],
  },
  {
    slug: 'spiderman-premium-combo',
    name: 'Spider-Man Premium Bundle',
    description: '2 keychains + Spiderman 3D model — our most premium set',
    combo_price: '899',
    combo_price_themed: '999',
    items: [
      { slug: 'spiderman-web-keychain', quantity: 1 },
      { slug: 'spider-man', quantity: 1 },
      { slug: 'spiderman-model', quantity: 1 },
    ],
  },
];

function buildComboFromCatalog(def, productsBySlug) {
  const items = def.items
    .map((req) => {
      const p = productsBySlug[req.slug];
      if (!p) return null;
      return {
        product: p.id,
        product_name: p.name,
        product_slug: p.slug,
        product_price: String(p.price),
        image_url: p.image_url || '',
        quantity: req.quantity,
      };
    })
    .filter(Boolean);

  if (items.length !== def.items.length) return null;

  const individual = items.reduce(
    (sum, item) => sum + parseFloat(item.product_price) * item.quantity,
    0
  );
  const comboPrice = parseFloat(def.combo_price);

  return {
    slug: def.slug,
    name: def.name,
    description: def.description,
    combo_price: def.combo_price,
    combo_price_themed: def.combo_price_themed || null,
    individual_total: individual.toFixed(2),
    savings: Math.max(0, individual - comboPrice).toFixed(2),
    image_url: items[0]?.image_url || '',
    items,
    trigger_product_ids: items.map((i) => i.product),
  };
}

/** Build combos from product catalog (works even when API combo data is stale) */
export async function resolveCombosFromProducts() {
  try {
    const products = await productAPI.getAll();
    const bySlug = Object.fromEntries(products.map((p) => [p.slug, p]));
    return COMBO_CATALOG.map((def) => buildComboFromCatalog(def, bySlug)).filter(Boolean);
  } catch (err) {
    console.error('Failed to resolve combos from products:', err);
    return [];
  }
}

/** Prefer API combos (authoritative DB data), then catalog-built combos */
export async function loadCombos(apiFetch) {
  try {
    const apiCombos = await apiFetch();
    if (Array.isArray(apiCombos) && apiCombos.length > 0) {
      return apiCombos;
    }
  } catch {
    // fall through to catalog
  }

  return resolveCombosFromProducts();
}

export function getComboPrice(combo, boxVariant = 'standard') {
  if (boxVariant === 'themed' && combo.combo_price_themed) {
    return parseFloat(combo.combo_price_themed);
  }
  return parseFloat(combo.combo_price);
}
